export { default } from './LazyPromoVideo';
